import { history, useIntl } from '@umijs/max';
import { Button, Result } from 'antd';

/**
 * 403 无权限页面
 *
 * 当用户访问没有权限的路由时显示此页面。
 * 通过 ProLayout 的 unAccessible 属性集成，
 * 当路由配置了 access 属性且用户权限不满足时自动展示。
 *
 * Requirements: 5.5, 11.4
 */
const NoAccessPage: React.FC = () => {
  const intl = useIntl();

  return (
    <Result
      status="403"
      title="403"
      subTitle={intl.formatMessage({ id: 'pages.403.subTitle' })}
      extra={
        <Button type="primary" onClick={() => history.push('/welcome')}>
          {intl.formatMessage({ id: 'pages.403.buttonText' })}
        </Button>
      }
    />
  );
};

export default NoAccessPage;
